import { getKitFields } from '@cheqroom/api';
import { selectFieldDefs } from '@cheqroom/components';
import { useMemo } from 'react';

import useCustomFields from '../custom-fields/use-custom-fields.hook';
import { EXCLUDE_KIT_FIELDS } from './exclude-kit-fields';

/** The kit field defs for `fieldIds`, in that order, minus the fields that have no inline variant. */
export const useKitInfoFieldDefs = (fieldIds: string[]) => {
	const customFields = useCustomFields({ type: 'kits' });

	return useMemo(() => {
		const allFieldDefs = getKitFields({ customFields }).filter((field) => !EXCLUDE_KIT_FIELDS.includes(field.id));
		return selectFieldDefs(allFieldDefs, fieldIds);
	}, [customFields, fieldIds]);
};

/** The ids of the inline fields the user turned on. A field turned off must not render. */
export const getVisibleFieldIds = (fieldVisibility: Record<string, boolean> | null | undefined) =>
	Object.entries(fieldVisibility ?? {})
		.filter(([, visible]) => visible)
		.map(([fieldId]) => fieldId);
